import React from 'react';
import "./App.css";
import Navigation from "./components/Desktop/Navigation";

const TermsPage = () => {
    window.scrollTo(0, 0)
    return (
        <>
            <Navigation />
            <div className='termsContainer'>
                <h1 className='termsHeading'>Terms & Conditions</h1>
                <p>Terms and conditions content goes here.</p>
            </div>
        </>
    )
}

export default TermsPage;

